<template>
  <VideoPlayer
    :playback-id="props.playbackId"
    :poster="posterGif"
    :poster-webp="posterWebp"
    :title="props.title"
    autoplay="any"
  />
</template>

<script setup lang="ts">
interface MuxVideoPlayerProps {
  playbackId: string
  gifStart?: number
  posterDimension?: 'width' | 'height'
  title?: string
}

const props = withDefaults(defineProps<MuxVideoPlayerProps>(), {
  gifStart: 0,
  posterDimension: 'width',
  title: 'Wait Mate',
})

const posterParams = computed(
  () => `${props.posterDimension}=640&fps=10&start=${props.gifStart}`,
)

const posterGif = computed(
  () =>
    `https://image.mux.com/${props.playbackId}/animated.gif?${posterParams.value}`,
)

const posterWebp = computed(
  () =>
    `https://image.mux.com/${props.playbackId}/animated.webp?${posterParams.value}`,
)
</script>
